var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "navbar"
  }, [_c('div', {
    staticClass: "navbar-section"
  }, [_c('router-link', {
    staticClass: "navbar-item",
    attrs: {
      "to": "/about"
    }
  }, [_vm._v("Marcia Halperin Pottery")]), _vm._v(" "), _c('router-link', {
    staticClass: "navbar-item ",
    attrs: {
      "to": "/gallery"
    }
  }, [_vm._v("Gallery")])], 1), _vm._v(" "), _c('div', {
    staticClass: "navbar-section"
  }, [_c('router-link', {
    staticClass: "navbar-item",
    attrs: {
      "to": "/contact"
    }
  }, [_vm._v("Contact")])], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-60cfaa5c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Navbar.vue
// module id = ey46
// module chunks = 1